/**
 * Centralized icon exports from Lucide React
 * This provides consistent icons across the application
 */
import {
  // Navigation
  Home,
  Users,
  ClipboardList,
  Building2,
  Settings,
  Search,
  Menu,
  X,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ArrowLeft,
  ArrowRight,
  ExternalLink,
  
  // Actions
  Plus,
  Edit,
  Trash2,
  Save,
  Check,
  Copy,
  Download,
  Upload,
  RefreshCw,
  MoreHorizontal,
  MoreVertical,
  
  // User & Auth
  User,
  UserPlus,
  Users as UsersIcon,
  LogOut,
  LogIn,
  Key,
  Shield,
  
  // Content
  FileText,
  File,
  Folder,
  Image,
  Calendar,
  Clock,
  Tag,
  Star,
  Heart,
  Flag,
  
  // Communication
  Mail,
  MessageSquare,
  Bell,
  
  // Data & Charts
  BarChart2,
  LineChart,
  PieChart,
  TrendingUp,
  TrendingDown,
  Activity,
  
  // Status
  AlertCircle,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Info,
  HelpCircle,
  
  // Media
  Play,
  Pause,
  Eye,
  EyeOff,
  
  // Layout
  Grid,
  List,
  Layers,
  Layout,
  Columns,
  
  // Sports specific
  Target,
  Award,
  Trophy,
  Medal,
  Zap,
  
  // Misc
  Sun,
  Moon,
  Globe,
  MapPin,
  Filter,
  SlidersHorizontal,
  Command
} from 'lucide-react';

// Re-export all icons
export {
  // Navigation
  Home,
  Users,
  ClipboardList,
  Building2,
  Settings,
  Search,
  Menu,
  X,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ArrowLeft,
  ArrowRight,
  ExternalLink,
  
  // Actions
  Plus,
  Edit,
  Trash2,
  Save,
  Check,
  Copy,
  Download,
  Upload,
  RefreshCw,
  MoreHorizontal,
  MoreVertical,
  
  // User & Auth
  User,
  UserPlus,
  UsersIcon,
  LogOut,
  LogIn,
  Key,
  Shield,
  
  // Content
  FileText,
  File,
  Folder,
  Image,
  Calendar,
  Clock,
  Tag,
  Star,
  Heart,
  Flag,
  
  // Communication
  Mail,
  MessageSquare,
  Bell,
  
  // Data & Charts
  BarChart2,
  LineChart,
  PieChart,
  TrendingUp,
  TrendingDown,
  Activity,
  
  // Status
  AlertCircle,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Info,
  HelpCircle,
  
  // Media
  Play,
  Pause,
  Eye,
  EyeOff,
  
  // Layout
  Grid,
  List,
  Layers,
  Layout,
  Columns,
  
  // Sports specific
  Target,
  Award,
  Trophy,
  Medal,
  Zap,
  
  // Misc
  Sun,
  Moon,
  Globe,
  MapPin,
  Filter,
  SlidersHorizontal,
  Command
};

// Custom soccer ball icon (Lucide doesn't have one)
export const SoccerBall = ({ size = 24, className = '', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a10 10 0 0 1 0 20" />
    <path d="M12 2a10 10 0 0 0 0 20" />
    <path d="M12 2v20" />
    <path d="M2 12h20" />
    <path d="m4.93 4.93 14.14 14.14" />
    <path d="m19.07 4.93-14.14 14.14" />
  </svg>
);

// Default icon props for consistency
export const defaultIconProps = {
  size: 20,
  strokeWidth: 2
};

// Icon size presets
export const iconSizes = {
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32
};
